import { MenuItem, Theme } from '@mui/material';
import React from 'react';
import NavModal from '../MenuItemTypes/NavModal';

const buttonSx = (theme: Theme) => ({
  '& button': {
    width: 'fit-content',
  },
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    boxShadow: 'none',
  },
  // Outer button Container
  [theme.breakpoints.down('sm')]: {
    minWidth: theme.spacing(3),
    height: theme.spacing(3),
  },
  minWidth: theme.spacing(4),
  height: theme.spacing(4),

  // Fonts
  ...theme.typography.subtitle2,
  [theme.breakpoints.up('xs')]: {
    ...theme.typography.subtitle1,
  },
  // Icon
  '& svg': {
    display: 'block',
    fontSize: 'large',
  },
  '&:hover ': {
    backgroundColor: theme.palette.action.focus,
  },
});

const subMenuItemButtonSx = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',

  '& button': {
    boxShadow: 'none',
    maxHeight: theme.spacing(5),
    textTransform: 'capitalize',
    width: 'fit-content',
  },
  '& button:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
  },
});

interface ModalMenuItem {
  component?: React.ReactNode;
}
interface ModalMenuProps {
  modalMenuItems: ModalMenuItem[];
  anchorRef: React.RefObject<HTMLButtonElement>;
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MoreOptionsButtonModal: React.FC<React.PropsWithChildren<ModalMenuProps>> = (props) => {
  const {
    modalMenuItems, anchorRef, isModalOpen, setIsModalOpen,
  } = props;
  return (
    <NavModal
        // data-testid="buttonModal"
      anchorRef={anchorRef}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    >
      {modalMenuItems
          && modalMenuItems.map((navItem) => (
            <MenuItem
              sx={[
                buttonSx,
                subMenuItemButtonSx,
              ]}
              key={String(navItem.component)}
            >
              {navItem.component}
            </MenuItem>
          ))}
    </NavModal>
  );
};
export default MoreOptionsButtonModal;
